/**
 * 예약 게시 관련 설정 상수
 */

// 예약 게시 최소 대기 시간 (분)
export const MIN_SCHEDULE_MINUTES = 0;

// 예약 게시 최소 대기 시간 (밀리초)
export const MIN_SCHEDULE_MS = MIN_SCHEDULE_MINUTES * 60 * 1000;

// 현재 시간 + 최소 대기 시간을 반환하는 헬퍼 함수
export const getMinScheduleDateTime = () => {
  const now = new Date();
  return new Date(now.getTime() + MIN_SCHEDULE_MS);
};

// 주어진 시간이 최소 대기 시간을 만족하는지 확인하는 함수
export const isValidScheduleTime = (scheduleDateTime) => {
  const now = new Date();
  const timeDifference = scheduleDateTime.getTime() - now.getTime();
  return timeDifference >= MIN_SCHEDULE_MS;
};